import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SmallAndAbove } from '@lichtblick/theme/utils/breakpoints';
import classNames from 'classnames';
import styles from './image.module.scss';
export const Image = ({ className, description, url, ...pictureProps })=>/*#__PURE__*/ _jsxs("picture", {
        ...pictureProps,
        className: classNames('image', className),
        children: [
            url.desktop && /*#__PURE__*/ _jsx("source", {
                className: styles.image,
                media: SmallAndAbove,
                srcSet: url.desktop
            }),
            /*#__PURE__*/ _jsx("img", {
                alt: description,
                className: styles.image,
                loading: "lazy",
                src: url.mobile
            })
        ]
    });

//# sourceMappingURL=image.js.map